import type { QuestScope } from "#quest-types";

/**
 * The `user_quest.adcode` of a global quest. The column predates global quests and cannot become
 * nullable (the actor schema only takes additive migrations), and no map adcode is 0.
 */
export const GLOBAL_QUEST_ADCODE = 0;

/** The `user_quest.adcode` a quest's row records. */
export function questScopeAdcode(scope: QuestScope): number {
  return scope.kind === "city" ? scope.adcode : GLOBAL_QUEST_ADCODE;
}

/**
 * Whether a quest is offered where the learner is: a global quest everywhere, a city quest only
 * in its city. `currentAdcode` is `null` before the first journey and on the road.
 */
export function isQuestOfferedAt(scope: QuestScope, currentAdcode: number | null): boolean {
  return scope.kind === "global" || scope.adcode === currentAdcode;
}
